export const environment = {
  production: false,
  apiUrl: 'https://dev-api.b2btravelagency.com/',
  flightApi: 'https://dev-booking.b2btravelagency.com/',
  imageUrl: 'https://book-staging-bucket.s3.ap-south-1.amazonaws.com/',
  logoUrl: 'assets/images/b2b-logo.png',
  showOrgSettingsAllTabs: true,
  showWhitelabel: false,
  client: 'B2B Travel Agency',
  clientAbbr: 'B2B',
  // Locale for every price / number shown in the app: 'en-IN' -> 1,00,000.00, 'en-US' -> 100,000.00
  numberFormat: 'en-IN',
  // Decimal places for every price (2 -> 1,500.00, 0 -> 1,500)
  numberDecimals: 2,
  clientShort: 'BookOtrip',
  logoHeight: '55',
  whitelabelCustomJs: 'https://book-staging-bucket.s3.ap-south-1.amazonaws.com/whitelabel/custom.js',
  whitelabelStyleCss: 'https://book-staging-bucket.s3.ap-south-1.amazonaws.com/whitelabel/style.css'
};